import { CheckMark } from 'ui/components/CheckMark'
import { DateTime } from 'ui/components/DateTime'
import { FrequencyLabel } from 'ui/components/Labels'
import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'
import { AlertsTooltip } from '~bank-documents/components/AlertsTooltip'
import { RelatedCompany } from '~bank-documents/components/RelatedCompany'
import { DocumentsPaths } from '~bank-documents/constants'
import { DocumentItem } from '~bank-documents/types/documentList'

import { getSubjectType } from './utils/getSubjectType'

type DocumentTableColumnParams = {
  onDocumentDelete: (documentData: { id: number; name: string }) => void
  sortFields: string[]
}

export const columns = ({ onDocumentDelete, sortFields }: DocumentTableColumnParams): TableColumn<DocumentItem>[] => [
  {
    title: 'Document Name',
    sortable: sortFields.includes('name'),
    key: 'name',
    align: 'left',
    width: '200px',
    render: (item) => (
      <Link to="/documents/$documentId" params={{ documentId: item.id.toString() }}>
        {item.name}
      </Link>
    )
  },
  {
    title: 'Internal',
    sortable: sortFields.includes('internal'),
    key: 'internal',
    render: ({ internal }) => (internal ? <CheckMark value rounded /> : null)
  },
  {
    title: 'Subject',
    align: 'left' as const,
    sortable: sortFields.includes('subject'),
    render: ({ subject }) => getSubjectType(subject)
  },
  {
    title: 'Relationship',
    align: 'left' as const,
    sortable: sortFields.includes('relationships'),
    render: ({ relationships }) =>
      relationships.length > 0 && <RelatedCompany asInfoBlock={false} relatedCompanies={relationships} />
  },
  {
    title: 'Frequency',

    key: 'frequency',
    align: 'left',
    sortable: sortFields.includes('frequency'),
    render: ({ frequency }) => <FrequencyLabel name={frequency} />
  },
  {
    title: 'Expiration Date',
    sortable: sortFields.includes('expirationDate'),
    key: 'expirationDate',
    align: 'left',
    render: ({ expirationDate }) => <DateTime date={expirationDate} />
  },
  {
    align: 'left',
    title: 'Alerts',
    render: (item) => <AlertsTooltip alerts={item.alerts} id={item.id} />
  },
  {
    align: 'left',
    title: 'Actions',
    width: '50px',
    render: (item) => (
      <TableActions
        items={[
          {
            type: 'edit',
            url: `/documents/${item.id}/edit?returnUrl=${DocumentsPaths.LIST}`
          },
          {
            type: 'delete',
            onClick: () => onDocumentDelete({ id: item.id, name: item.name })
          }
        ]}
      />
    )
  }
]
